import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayoutModern = styled(Paper)({
    height: `calc(100% - 48px)`,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
})

export default TicketAdvancedLayoutModern;

